export var PromotionAction;
(function (PromotionAction) {
    PromotionAction["NO_CHANGES"] = "no changes";
    PromotionAction["CREATE"] = "create";
    PromotionAction["UPDATE"] = "update";
    PromotionAction["DELETE"] = "delete";
})(PromotionAction || (PromotionAction = {}));
//# sourceMappingURL=promotion.js.map